import CircularProgress from "@mui/material/CircularProgress";
import { type FC } from "react";
import { TriggerButton } from "../../Link";
import { useDrawer } from "../context";
import { type NextButtonProps } from "../NextButton";

const NextButton: FC<NextButtonProps & { onCloseCallback?: () => void; isLoading?: boolean }> = ({
	numberOfSteps,
	customFunction,
	label,
	onCloseCallback,
	isLoading,
	...rest
}) => {
	const { hideMultistepDrawer, step, nextStep } = useDrawer();

	const handleClick = async (finalFunction: () => void) => {
		if (customFunction) {
			/* MDN OK:
			https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/await
			and it is intended here */
			// eslint-disable-next-line
			const final = await customFunction();
			final && finalFunction();
		} else {
			finalFunction();
		}
	};

	const startIcon = isLoading ? <CircularProgress size={16} color="inherit" /> : undefined;

	if (step < numberOfSteps - 1)
		return (
			<TriggerButton
				data-test="multistep-drawer-next-button"
				onClick={() => handleClick(nextStep)}
				startIcon={startIcon}
				{...rest}
			>
				{label ? label : "Pokračovat"}
			</TriggerButton>
		);
	return (
		<TriggerButton
			data-test="multistep-drawer-confirm-button"
			onClick={() => {
				onCloseCallback && onCloseCallback();
				handleClick(hideMultistepDrawer);
			}}
			startIcon={startIcon}
			{...rest}
		>
			{label ? label : "Rozumím"}
		</TriggerButton>
	);
};

export default NextButton;
